<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>

        <d-col md="12" class="form-group">
          <d-form>
            <d-card class="card-small">
              <!-- Card Header -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Lista de tipos de chamados</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <d-list-group>
                  <d-list-group-item v-for="(row, index) in typeList" :key="index" class="d-flex px-3">
                    <span class="text-semibold text-fiord-blue col pl-0">
                      <d-input v-model="row.name" class="input-hidden" @change="capitalizeInput('typeList', index)" placeholder="Adicione um novo tipo"/>
                    </span>
                    <span class="ml-auto text-right text-semibold col-auto px-0">
                      <i class="fas fa-plus" @click="addRowType()" v-if="index+1 == typeList.length"></i>
                      <i class="fas fa-minus" @click="removeRow('typeList', index)"></i>
                      <i class="fas fa-save" @click="saveType(index)"></i>
                    </span>
                  </d-list-group-item>
                </d-list-group>
              </d-card-body>

            </d-card>
          </d-form>
        </d-col>

        <d-col md="12" class="form-group">
          <d-form>
            <d-card class="card-small">
              <!-- Card Header -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Lista de cores do cronômetro</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <d-list-group>
                  <d-list-group-item v-for="(row, index) in colorList" :key="index" class="px-3 ">
                    <d-form-row class="align-items-center">
                      <d-col class="form-group">
                        <d-input v-model="row.name" @change="capitalizeInput('colorList', index)" placeholder="Nome"/>
                      </d-col>
                      <d-col cols="3" sm="3" md="3" lg="2" class="form-group d-flex">
                        <d-input-group prepend="Cor">
                          <d-input type="color" v-model="row.color" class="input-color" placeholder="Adicione uma cor"/>
                        </d-input-group>
                      </d-col>
                      <d-col class="form-group d-flex">
                        <d-input-group append="d">
                          <d-input type="number" min="0" v-model="row.days" placeholder="Dias"/>
                        </d-input-group>
                        <d-input-group append="h">
                          <d-input type="number" min="0" v-model="row.hours" placeholder="Horas"/>
                        </d-input-group>
                        <d-input-group append="m">
                          <d-input type="number" min="0" v-model="row.minutes" placeholder="Minutos"/>
                        </d-input-group>
                      </d-col>
                      <d-col cols class="ml-auto text-right text-semibold px-0">
                        <div >
                          <i class="fas fa-plus" @click="addRowColor()" v-if="index+1 == colorList.length"></i>
                          <i class="fas fa-minus" @click="removeRow('colorList', index)"></i>
                          <i class="fas fa-save" @click="saveColor(index)"></i>
                        </div>
                      </d-col>
                    </d-form-row>
                  </d-list-group-item>
                </d-list-group>
              </d-card-body>

            </d-card>
          </d-form>
        </d-col>

      </d-row>

    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import { stringfy, capitalize } from '_utils/string';
import TicketService from '_services/rest/modules/ticket';
import { OPTION, COLOR_OPTION } from './SettingsModel';

export default {
  name: 'type-form',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    colorList() {
      const { colors } = this.$store.state.settings;
      if (colors && colors.length > 0) {
        return colors;
      }
      return [{ ...COLOR_OPTION }];
    },
    typeList() {
      const { types } = this.$store.state.settings;
      if (types && types.length > 0) {
        return types;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'addType',
      'getType',
      'addColor',
      'getColor',
    ]),
    addRowType() {
      return this.addType({ ...OPTION });
    },
    addRowColor() {
      return this.addColor({ ...COLOR_OPTION });
    },
    capitalizeInput(list, index) {
      this[list][index].name = capitalize(this[list][index].name);
    },
    checkEmptyOptions(list) {
      if (this[list].length === 0) {
        const option = (list === 'typeList') ? OPTION : COLOR_OPTION;
        this[list].push({ ...option });
      }
    },
    formatSlug(option) {
      option.slug = stringfy(option.name);
    },
    getOptions() {
      this.getType();
      this.getColor();
    },
    removeRow(list, index) {
      if (this[list][index].id) {
        TicketService.removeOption(this[list][index].id, list)
          .then(() => this.activeAlert({ message: 'Opção deletada com sucesso', theme: 'success' }))
          .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }));
      }
      this[list].splice(index, 1);
      this.checkEmptyOptions(list);
    },
    saveType(index) {
      this.formatSlug(this.typeList[index]);
      TicketService.saveOption(this.typeList[index], '/type')
        .then(() => {
          this.activeAlert({ message: 'Tipos de chamado salvos com sucesso', theme: 'success' });
          this.getType();
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    setTime(row) {
      const h = 60 * parseInt(row.hours, Number);
      const m = parseInt(row.minutes, Number);
      const d = 24 * 60 * parseInt(row.days, Number);
      return d + h + m;
    },
    saveColor(index) {
      const color = {
        id: this.colorList[index].id,
        name: this.colorList[index].name,
        time: this.setTime(this.colorList[index]),
        color: this.colorList[index].color,
      };
      TicketService.saveOption(color, '/color')
        .then(() => {
          this.getColor();
          this.activeAlert({ message: 'Cores do cronômetro salvas com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';

.input-hidden {
  width: 100%;
  border: 0;
  padding: 0;
  color: #3D5170;
  font-weight: 400;
  font-size: 15px;
  &:focus {
    box-shadow: none;
    border: 0;
  }
}

.input-group {
  min-width: 5rem;
}

.input-color {
  height: 100%;
}

.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red
  }
  &.fa-save:hover{
    color: $blue;
  }
}
</style>
